export { default as SVGPrice } from './SVGPrice';
